import { ColumnDetails } from '../../../../../../grid/types/common';
import { TargetsColumn, TargetsColumnKeys } from '../types';
import { html } from 'lit';
import { translateFn } from '../../../../../../utils/translator.helper';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';

export function nameRenderer(rowData, columnDetails: ColumnDetails<TargetsColumn, TargetsColumnKeys>) {
  const peInfo = rowData.item as ProtectedEntity;
  const cellValue = Translator.translateProtectedEntityNameByType(
    peInfo[columnDetails.key],
    peInfo.type,
    Constants.ProductTypes.GRAVITY_ZONE_CLOUD
  );
  return html` <span class="cell-label">${cellValue}</span> `;
}

export function policyRenderer(rowData, columnDetails: ColumnDetails<TargetsColumn, TargetsColumnKeys>) {
  const rowItem = rowData.item;
  const cellValue = rowItem.activePolicy?.policyName ?? '-';
  return html` <span class="cell-label">${cellValue}</span> `;
}

export function inheritedFromRenderer(rowData, columnDetails: ColumnDetails<TargetsColumn, TargetsColumnKeys>) {
  const peInfo = rowData.item as ProtectedEntity;
  let cellValue = columnDetails.key.split('.').reduce((acc, key) => acc && acc[key], peInfo);
  if (!cellValue) {
    cellValue = '-';
  } else {
    cellValue = Translator.translateProtectedEntityNameByType(
      cellValue,
      peInfo.assignedPolicy?.inheritedFrom?.type,
      Constants.ProductTypes.GRAVITY_ZONE_CLOUD
    );
  }
  return html` <span class="cell-label">${cellValue}</span> `;
}

export function enforceRenderer(rowData, columnDetails: ColumnDetails<TargetsColumn, TargetsColumnKeys>) {
  const rowItem = rowData.item;
  let cellValue = columnDetails.key.split('.').reduce((acc, key) => acc && acc[key], rowItem);
  if (cellValue) {
    if (!rowItem.activePolicy.inheritedFrom.id || rowItem.activePolicy.inheritedFrom.id === '') {
      cellValue = translateFn('Forcing');
    } else {
      cellValue = translateFn('Is forced');
    }
  } else {
    cellValue = '-';
  }

  return html` <span class="cell-label">${cellValue}</span> `;
}
